module.exports = __webpack_public_path__ + "assets/img/12-bak.63c3465b.png";